import React from 'react';
import { SmartphoneIcon, CreditCardIcon, CheckCircleIcon, WalletIcon } from 'lucide-react';
interface HeroProps {
  openModal: () => void;
}
export function Hero({
  openModal
}: HeroProps) {
  return <div className="relative overflow-hidden bg-white pt-16 pb-20 lg:pt-24 lg:pb-28" data-id="element-129">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-130">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-131">
          <div className="text-center lg:text-left" data-id="element-132">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-50 text-emerald-700 text-sm font-semibold mb-6 border border-emerald-100" data-id="element-133">
              <span className="relative flex h-2 w-2" data-id="element-134">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" data-id="element-135"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" data-id="element-136"></span>
              </span>
              100% Gratis para usuarios
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-gray-900 tracking-tight leading-tight mb-6" data-id="element-137">
              Tu pasaporte al{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-600 to-teal-500" data-id="element-138">
                ahorro inteligente
              </span>
            </h1>

            <p className="text-lg sm:text-xl text-gray-600 mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-139">
              Únete a ClubAhorra y accede a descuentos exclusivos en cientos de
              comercios. Usa tu tarjeta o la App y empieza a pagar menos hoy
              mismo.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-10" data-id="element-140">
              <div className="flex flex-col sm:flex-row gap-3" data-id="element-141">
                <a href="https://apps.apple.com/pe/app/club-ahorra/id6756685705" target="_blank" rel="noopener noreferrer" className="inline-flex items-center bg-black text-white px-5 py-3 rounded-lg hover:bg-gray-800 transition-colors shadow-md" data-id="element-142">
                  <svg className="h-7 w-7 mr-2" viewBox="0 0 24 24" fill="currentColor" data-id="element-143">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" data-id="element-144" />
                  </svg>
                  <div className="text-left" data-id="element-145">
                    <div className="text-[10px] leading-tight" data-id="element-146">Descarga en</div>
                    <div className="text-sm font-semibold -mt-0.5" data-id="element-147">
                      App Store
                    </div>
                  </div>
                </a>

                <a href="https://play.google.com/store/apps/details?id=com.ipse.benefika.clubahorra" target="_blank" rel="noopener noreferrer" className="inline-flex items-center bg-black text-white px-5 py-3 rounded-lg hover:bg-gray-800 transition-colors shadow-md" data-id="element-148">
                  <svg className="h-7 w-7 mr-2" viewBox="0 0 24 24" fill="currentColor" data-id="element-149">
                    <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" data-id="element-150" />
                  </svg>
                  <div className="text-left" data-id="element-151">
                    <div className="text-[10px] leading-tight" data-id="element-152">
                      Disponible en
                    </div>
                    <div className="text-sm font-semibold -mt-0.5" data-id="element-153">
                      Google Play
                    </div>
                  </div>
                </a>
              </div>

              <button onClick={openModal} className="inline-flex items-center justify-center gap-2 px-8 py-3.5 text-base font-semibold text-gray-700 bg-white border border-gray-200 rounded-full hover:bg-gray-50 transition-all hover:border-gray-300" data-id="element-154">
                <CreditCardIcon className="h-5 w-5" data-id="element-155" />
                Crear Cuenta Gratis
              </button>
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-6 text-sm text-gray-500 font-medium" data-id="element-156">
              <div className="flex items-center gap-1.5" data-id="element-157">
                <CheckCircleIcon className="h-4 w-4 text-emerald-500" data-id="element-158" />
                <span data-id="element-159">Gratis para siempre</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-160">
                <CheckCircleIcon className="h-4 w-4 text-emerald-500" data-id="element-161" />
                <span data-id="element-162">Cientos de Comercios</span>
              </div>
            </div>
          </div>

          <div className="relative lg:h-[600px] flex items-center justify-center" data-id="element-163">
            {/* Abstract Background Blobs */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-emerald-100 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob" data-id="element-164"></div>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-teal-100 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob animation-delay-2000 ml-20 -mt-20" data-id="element-165"></div>

            {/* Phone Screenshot */}
            <div className="relative z-10 transform rotate-[-6deg] hover:rotate-0 transition-transform duration-500" data-id="element-166">
              <img src="https://cdn.magicpatterns.com/uploads/uWbHTeN5tsZPacn5gq3nUL/pasted-image.webp" alt="ClubAhorra App - Mi Tarjeta Digital" className="w-[320px] sm:w-[360px] rounded-[2.5rem] shadow-2xl" data-id="element-167" />
            </div>

            {/* Floating Card */}
            <div className="absolute bottom-20 -right-4 lg:right-10 bg-gradient-to-br from-gray-900 to-gray-800 rounded-xl p-6 shadow-2xl w-72 text-white transform rotate-[6deg] hover:rotate-0 transition-transform duration-500 border border-gray-700" data-id="element-168">
              <div className="flex justify-between items-start mb-8" data-id="element-169">
                <div className="flex items-center gap-2" data-id="element-170">
                  <div className="bg-emerald-500 p-1 rounded" data-id="element-171">
                    <WalletIcon className="h-4 w-4 text-white" data-id="element-172" />
                  </div>
                  <span className="font-bold text-sm" data-id="element-173">ClubAhorra</span>
                </div>
                <div className="h-6 w-10 bg-gray-600 rounded opacity-50" data-id="element-174"></div>
              </div>
              <div className="space-y-2 mb-6" data-id="element-175">
                <div className="h-3 w-32 bg-gray-600 rounded opacity-50" data-id="element-176"></div>
                <div className="h-3 w-20 bg-gray-600 rounded opacity-50" data-id="element-177"></div>
              </div>
              <div className="flex justify-between items-center" data-id="element-178">
                <div className="text-sm font-mono text-gray-400" data-id="element-179">
                  ALEX RAMIREZ
                </div>
                <div className="h-6 w-6 rounded-full bg-emerald-500" data-id="element-180"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}